module.exports = __webpack_public_path__ + "img/caret-right.3cbdb178.svg";